var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{ login: _vm.isLogin }},[_vm._v(" Copyright 2021. HYUNDAI MOBIS. ALL RIGHTS RESERVED ")])}
var staticRenderFns = []

export { render, staticRenderFns }